import React from 'react'
import { objectLang } from "../functions"
import Modal from "react-bootstrap/Modal"
import { LoaderClass } from "../elements/LoaderClass"
import { SearchResultItem } from "../elements/SearchResultItem"

export class ViewResultsSearchClass extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            expanded: {
                public: false,
                private: false,
                google: false
            }
        }
    }

    toggleSection = (section) => {
        this.setState(prev => ({
            expanded: {
                ...prev.expanded,
                [section]: !prev.expanded[section]
            }
        }))
    }

    renderCategory(categoryName, blocks) {
        const { expanded } = this.state
        const { requestSearch } = this.props.data
        const lang = objectLang().language
        const l = lang.lang

        return expanded[categoryName] && blocks.map((block, i) => {
            const { items, type, isPublic = false, isGoogle = false } = block
            return items.map((item, j) => (
                <SearchResultItem
                    key={`${categoryName}-${type}-${i}-${j}`}
                    item={item}
                    type={type}
                    isPublic={isPublic}
                    isGoogle={isGoogle}
                    lang={l}
                    requestSearch={requestSearch}
                />
            ))
        })
    }


    render() {
        const { data } = this.props
        const folders = data.body.folders || []
        const links = data.body.links || []
        const notes = data.body.notes || []
        const publicFolders = data.publicBody.folders || []
        const publicLinks = data.publicBody.links || []
        const publicNotes = data.publicBody.notes || []
        const googleFolders = data.googleBody.documents.folders || []
        const googleFiles = data.googleBody.documents.links || []
        const lang = objectLang().language

        const countPublic = publicFolders.length + publicLinks.length + publicNotes.length
        const countPrivate = folders.length + links.length + notes.length
        const countGoogle = googleFolders.length + googleFiles.length

        if (!countPublic && !countPrivate && !countGoogle) {
            return (
                <Modal.Body className={'founded-items'}>
                    <h5 className={'text-center text-success'}>
                        {data.title}
                        {data.loading && <LoaderClass />}
                    </h5>
                </Modal.Body>
            )
        }

        // Подготовка блоков для каждой категории
        const publicBlocks = [
            { type: 'folder', items: publicFolders, isPublic: true },
            { type: 'link', items: publicLinks, isPublic: true },
            { type: 'note', items: publicNotes, isPublic: true }
        ]

        const privateBlocks = [
            { type: 'folder', items: folders },
            { type: 'link', items: links },
            { type: 'note', items: notes }
        ]

        const googleBlocks = [
            { type: 'google-folder', items: googleFolders, isGoogle: true },
            { type: 'google-file', items: googleFiles, isGoogle: true }
        ]

        return (
            <Modal.Body className={'founded-items'}>
                {data.loading && <LoaderClass />}
                <h5 className={'text-center text-success'}>
                    {lang.messages.code_703}
                </h5>
                {/*<h6 className={'text-center text-success'}>*/}
                {/*    {`${lang.messages.code_704}`}<strong>{folders.length + publicFolders.length}</strong>&nbsp;*/}
                {/*    {`${lang.messages.code_705}`}<strong>{links.length + publicLinks.length}</strong>&nbsp;*/}
                {/*    {`${lang.messages.code_706}`}<strong>{notes.length + publicNotes.length}</strong>*/}
                {/*</h6>*/}

                {/* --- Public Block --- */}
                {countPublic > 0 && (
                    <div className="mb-2">
                        <button
                            className="btn btn-outline-primary w-100 mb-1 d-flex justify-content-between align-items-center"
                            onClick={() => this.toggleSection('public')}
                        >
                            <span>Общедоступное</span>
                            <span>{countPublic}</span>
                        </button>
                        {this.renderCategory('public', publicBlocks)}
                    </div>
                )}

                {/* --- Private Block --- */}
                {countPrivate > 0 && (
                    <div className="mb-2">
                        <button
                            className="btn btn-outline-secondary w-100 mb-1 d-flex justify-content-between align-items-center"
                            onClick={() => this.toggleSection('private')}
                        >
                            <span>Мои Линки</span>
                            <span>{countPrivate}</span>
                        </button>
                        {this.renderCategory('private', privateBlocks)}
                    </div>
                )}

                {/* --- Google Block --- */}
                {countGoogle > 0 && (
                    <div className="mb-2">
                        <button
                            className="btn btn-outline-success w-100 mb-1 d-flex justify-content-between align-items-center"
                            onClick={() => this.toggleSection('google')}
                        >
                            <span>Google Drive</span>
                            <span>{countGoogle}</span>
                        </button>
                        {this.renderCategory('google', googleBlocks)}
                    </div>
                )}
            </Modal.Body>
        )
    }
}
